import React from 'react';

const TeamAnalytics = ({ teamData }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Total Members</p>
            <p className="text-2xl font-bold" style={{color: '#e25820'}}>{teamData?.totalMembers || 0}</p>
            <p className="text-xs text-gray-500">Team size</p>
          </div>
          <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{backgroundColor: '#fef2f0'}}>
            <svg className="w-6 h-6" style={{color: '#e25820'}} fill="currentColor" viewBox="0 0 24 24">
              <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.5 7.5h-3A1.5 1.5 0 0 0 14.04 8.37L11.5 16H14v6h6z"/>
            </svg>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Players</p>
            <p className="text-2xl font-bold" style={{color: '#e25820'}}>{teamData?.activePlayers || 0}</p>
            <p className="text-xs text-gray-500">Active players</p>
          </div>
          <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{backgroundColor: '#fef2f0'}}>
            <svg className="w-6 h-6" style={{color: '#e25820'}} fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Staff</p>
            <p className="text-2xl font-bold" style={{color: '#e25820'}}>{teamData?.supervisors || 0}</p>
            <p className="text-xs text-gray-500">Supervisors</p>
          </div>
          <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{backgroundColor: '#fef2f0'}}>
            <svg className="w-6 h-6" style={{color: '#e25820'}} fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Sport</p>
            <p className="text-2xl font-bold" style={{color: '#e25820'}}>{teamData?.sport?.charAt(0).toUpperCase() + teamData?.sport?.slice(1) || 'N/A'}</p>
            <p className="text-xs text-gray-500">{teamData?.gender} • {teamData?.type}</p>
          </div>
          <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{backgroundColor: '#fef2f0'}}>
            <svg className="w-6 h-6" style={{color: '#e25820'}} fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamAnalytics; 